import PasswordFormContainer from './PasswordFormContainer';

export default PasswordFormContainer;
